var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, ClickEventListener, CloseEventListener, OpenEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class NotificationCenterAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onOpen = new OpenEventListener();
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
    }
    open() {
        if (this.isOpen()) {
            return;
        }
        this.setState({ open: true });
        this.onOpen.fire();
    }
    close() {
        if (!this.state.open) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.onClose.fire();
        }
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    getLimit() {
        return this.state.limit;
    }
    setLimit(limit) {
        this.setState({ limit });
    }
    setNotificationTitle(title) {
        this.setState({ title });
    }
    getNotificationTitle() {
        return this.state.title;
    }
    setOpen(open) {
        this.setState({ open });
    }
    isOpen() {
        return this.state.open;
    }
    getUnreadNotificationCount() {
        return this.state.unreadNotificationsCount;
    }
    setUnreadNotificationsCount(unreadNotificationsCount) {
        this.setState({ unreadNotificationsCount });
    }
    getCanDeleteNotificationOption() {
        return this.state.canDeleteNotification;
    }
    setCanDeleteNotificationOption(canDeleteNotification) {
        this.setState({ canDeleteNotification });
    }
    getCanMarkAllAsReadOption() {
        return this.state.canMarkAllAsRead;
    }
    setCanMarkAllAsReadOption(canMarkAllAsRead) {
        this.setState({ canMarkAllAsRead });
    }
    getCanMarkAsReadOption() {
        return this.state.canMarkAsRead;
    }
    setCanMarkAsReadOption(canMarkAsRead) {
        this.setState({ canMarkAsRead });
    }
    getCanMarkAsUnreadOption() {
        return this.state.canMarkAsUnread;
    }
    setCanMarkAsUnreadOption(canMarkAsUnread) {
        this.setState({ canMarkAsUnread });
    }
    getFirstPage() {
        return this.state.firstPage;
    }
    setFirstPage(firstPage) {
        this.setState({ firstPage });
    }
    setReadStatus(id, read) {
        const { data } = this.state;
        const index = data.findIndex((item) => item.id === id);
        const item = data[index];
        data.splice(index, 1, { ...item, read });
        this.setState({ data });
    }
    markAllAsRead() {
        const { data } = this.state;
        const newData = data.map(item => {
            item.read = true;
            return item;
        });
        this.setState({ data: newData });
    }
    deleteNotification(id) {
        const { data } = this.state;
        const newData = data.filter(notification => notification.id !== id);
        this.setState({ data: newData });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onOpen", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], NotificationCenterAPI.prototype, "onDoubleClick", void 0);
export default NotificationCenterAPI;
//# sourceMappingURL=notification-center-api.js.map